import ProfitLossHTMLPreviewBaseStrategy from './ProfitLossHTMLPreviewBaseStrategy'

export default function ProfitLossHTMLPreviewShowRatesStrategy () {}

ProfitLossHTMLPreviewShowRatesStrategy.prototype = new ProfitLossHTMLPreviewBaseStrategy();

ProfitLossHTMLPreviewShowRatesStrategy.prototype.init = function ( timeFormat, showSpentTime )
{
    ProfitLossHTMLPreviewBaseStrategy.prototype.init.call( this, timeFormat, showSpentTime );
    return this;
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getBillableAmountColHeaderText = function ()
{
    return this.message("report.profit_loss.billable_amount.header");
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getCostOfWorkColHeaderText = function ()
{
    return this.message("report.profit_loss.cost.header");
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getBillableAmountColSpan = function ()
{
    return 2;
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getBillableAmountRowSpan = function ()
{
    return 1;
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getCostOfWorkColSpan = function ()
{
    return 2;
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getCostOfWorkRowSpan = function ()
{
    return 1;
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.addSecondHeaderRowCells = function ( secondHeaderRow )
{
    this.addCell(
            secondHeaderRow,
            this.message( "report.profit_loss.rate.subheader" ) + " " + this.message("report.common.unit_rate", [SystemSettings.currencySign]),
            "rate"
    );

    this.addCell(
            secondHeaderRow,
            this.message("report.profit_loss.billable_amount.subheader") + " (" + SystemSettings.currencySign + ")",
            "amount"
    );

    this.addCell(
            secondHeaderRow,
            this.message( "report.profit_loss.rate.subheader" ) + " " + this.message("report.common.unit_rate", [SystemSettings.currencySign]),
            "rate"
    );

    this.addCell(
            secondHeaderRow,
            this.message("report.profit_loss.cost.subheader") + " (" + SystemSettings.currencySign + ")",
            "cost"
    );
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.addDataCells = function ( row )
{
    if (this.showSpentTime)
        this.addTimeValueCell( row, "spent" );

    this.addMoneyValueCell( row );
    this.addMoneyValueCell( row, "darkMoneyValueCell" );
    this.addMoneyValueCell( row );
    this.addMoneyValueCell( row, "darkMoneyValueCell" );
    this.addMoneyValueCell( row );
};

ProfitLossHTMLPreviewShowRatesStrategy.prototype.getDataColumnsCount = function ()
{
    return this.showSpentTime ? 6 : 5;
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/profitloss/ProfitLossHTMLPreviewShowRatesStrategy.js